import React, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react'

export interface LocaleFields {
  [key: string]: string | null
}
export const languageSlugs: string[] = [
  'ar',
  'zh-tw',
  'en',
  'fr',
  'de',
  'id',
  'it',
  'ja',
  'zh-cn',
  'pl',
  'pt',
  'ru',
  'es'
]

const languageCorrections: { [key: string]: string } = {
  'zh-hant-tw': 'zh-tw'
}

const defaultLanguage = 'en'

interface State {
  language: string // One of the slugs in languageSlugs above
  updateLanguage?: (language: string) => void
}

interface Props {
  initialLanguage?: string
  children: ReactNode
}

function getCorrectLanguageSlug(initialLang: string) {
  let lang = initialLang
  if (lang) {
    lang = lang.toLowerCase()
    lang = languageCorrections[lang] || lang
  }
  if (languageSlugs.includes(lang)) {
    return lang
  }
  return defaultLanguage
}

export const LocalizationContext = createContext({} as State)

export function LocalizationProvider({ children, initialLanguage }: Props) {
  const [language, setLanguage] = useState(defaultLanguage)

  const updateLanguage = (lang?: string) => {
    const corrected = getCorrectLanguageSlug(lang || '')
    setLanguage(corrected)
  }

  useEffect(() => {
    updateLanguage(initialLanguage)
  }, [initialLanguage])

  return (
    <LocalizationContext.Provider
      value={useMemo(() => ({ language, updateLanguage }), [language])}
    >
      {children}
    </LocalizationContext.Provider>
  )
}

// custom hook for consuming localization language
export function useLanguage() {
  const { language, updateLanguage } = useContext(LocalizationContext)
  return { language, updateLanguage }
}
